"use client";

import React, { useEffect, useState } from "react";
import { getWindow } from "../../../helpers/getWindow";
import { useCountry } from "../../../hooks/useCountry";
import { Button } from "../../Button";
import { Lightbox } from "../../Lightbox";
import { MenuContent } from "./content";
import styles from "./index.module.scss";
import type { MenuItemType } from "./types";

export const Menu: React.FC = () => {
    const window = getWindow();
    const [isOpen, setIsOpen] = useState(false);
    const country = useCountry();
    const [menuConfig, setMenuConfig] = useState<Array<MenuItemType>>([]);

    useEffect(() => {
        if (menuConfig.length === 0) {
            const fetchMenuConfig = async (): Promise<void> => {
                const menuConfig = (await import(`./config.${country}`).then(
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access
                    (mod) => mod.default
                )) as Array<MenuItemType>;
                setMenuConfig(menuConfig);
            };

            void fetchMenuConfig();
        }
    }, [country, menuConfig.length]);

    const lightboxCallback = (): void => {
        window?.requestAnimationFrame(() => {
            setIsOpen(!isOpen);
        });
    };

    return (
        <nav aria-label="Hauptmenü">
            <Button
                variant="unstyled"
                className={styles.button}
                onClick={lightboxCallback}
                aria-label="Menu öffnen"
            >
                <span className="icon-menu" />
            </Button>
            {isOpen ? (
                <Lightbox
                    callback={lightboxCallback}
                    zIndexKey="menu"
                    isFullscreen={!["de", "ch"].includes(country)}
                    backdropColor="white"
                    closeIconColor="blueDark"
                    trackPageImpression="none"
                    triggerAdReload="none"
                >
                    <MenuContent
                        items={menuConfig}
                        closeMenu={lightboxCallback}
                    />
                </Lightbox>
            ) : (
                <MenuContent
                    items={menuConfig}
                    closeMenu={() => undefined}
                    isSSR
                />
            )}
        </nav>
    );
};
